import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewChecked, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { KioskMoneyTransactionService } from 'src/app/services/kioskMoneyTransaction/kiosk-money-transaction.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { FiltersModel } from 'src/app/shared/models/FiltersModel.model';
import { MaintenanceOperationType, MaintenanceOperationTypeLabel } from 'src/app/shared/models/enums/maintenance-operation-type';
import { MoneyOperationType, MoneyOperationTypeLabel } from 'src/app/shared/models/enums/money-operation-type';
import { PaymentMethod, PaymentMethodLabel } from 'src/app/shared/models/enums/payment-method';
import { TransactionState, TransactionStateLabel } from 'src/app/shared/models/enums/transaction-state';
import { KioskMoneyTransactionModel } from 'src/app/shared/models/kiosk-money-transaction-model';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class TransactionsComponent implements AfterViewChecked {

  displayedColumns: string[] = ['code', 'snapTime', 'operationType', 'paymentMethod', 'kiosk', 'state', 'totalValue'];
  dataSource: MatTableDataSource<KioskMoneyTransactionModel>;
  editMode: boolean = false;
  numSelected: number;
  columnList: string[];
  filters: FiltersModel = {
    ColumnsToSearch: [],
    CurrentPage: 0,
    PageSize: 10,
    OrderColumn: null,
    OrderType: null,
    SearchText: null,
    FilterTags: []
  };
  kioksLimits: number;
  addKiosk: boolean;
  maintenanceOperationTypes = MaintenanceOperationType;
  maintenanceOperationTypesL = MaintenanceOperationTypeLabel;
  startDate = new FormControl();
  endDate = new FormControl();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private loadingService: LoadingService, private kioskMoneyTransactionService: KioskMoneyTransactionService, private cdRef: ChangeDetectorRef) {

    const $this = this;

    $this.startDate.valueChanges.subscribe(value => {
      $this.filters.StartDate = value;
    });

    $this.endDate.valueChanges.subscribe(value => {
      $this.filters.EndDate = value;
    });

    $this.loadingService.toggle("");

    $this.kioskMoneyTransactionService.GetAllColumnNames().subscribe((resp: string[]) => {
      $this.columnList = resp;
      $this.refreshList();
    });
  }

  selection = new SelectionModel<any>(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const $this = this;
    if ($this.dataSource == null || $this.dataSource == undefined) {
      return false;
    } else {
      $this.numSelected = $this.selection.selected.length;
      const numRows = $this.dataSource.data.length;
      return $this.numSelected === numRows;
    }
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  ngAfterViewChecked() {
    const $this = this;
    $this.cdRef.detectChanges();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  search() {
    const $this = this;
    $this.loadingService.toggle("");
    $this.refreshList();
  }

  refreshList() {
    const $this = this;


    if ($this.paginator != null) {
      $this.filters.PageSize = $this.paginator.pageSize;
      $this.filters.CurrentPage = $this.paginator.pageIndex;
    }

    $this.selection = new SelectionModel<any>(true, []);
    $this.numSelected = 0;
    $this.kioskMoneyTransactionService.GetAllKioskMoneyTransactions($this.filters).subscribe((resp) => {
      if (resp != null) {
        for (let index = 0; index < resp.kioskMoneyTransactions.length; index++) {
          const transaction: KioskMoneyTransactionModel = resp.kioskMoneyTransactions[index];
          transaction.snapTime = moment(transaction.snapTime, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY  HH:mm:ss');
        }
        $this.dataSource = new MatTableDataSource(resp.kioskMoneyTransactions);
        $this.dataSource.paginator = $this.paginator;
        $this.dataSource.sort = $this.sort;
        $this.loadingService.toggle("");
      }
    });
  }

  getMoneyOperationTypeLabel(type: MoneyOperationType): string {
    return MoneyOperationTypeLabel.get(type) || '-';
  }

  getPaymentMethodLabel(type: PaymentMethod): string {
    return PaymentMethodLabel.get(type) || '-';
  }

  getTransactionStateLabel(type: TransactionState): string {
    return TransactionStateLabel.get(type) || '-';
  }

  exportToCSV() {
    const $this = this;
    const csvData = $this.convertToCSV($this.dataSource.filteredData);
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none');
    a.href = url;
    a.download = 'transactions-' + moment().format('YYYYMMDD-HHmmss') + '.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  private convertToCSV(dataToConvert: KioskMoneyTransactionModel[]): string {
    const $this = this;
    const headers = ['CÓDIGO PERIODO', 'DATA', 'TIPO DE OPERAÇÃO', 'MEIO DE PAGAMENTO', 'QUIOSQUE', 'MONTANTE TOTAL'];
    const rows = [];
    for (let i = 0; i < dataToConvert.length; i++) {
      const data = dataToConvert[i];
      const row = [];
      row.push(data.kioskPeriod.code);
      row.push(data.snapTime);
      row.push($this.getMoneyOperationTypeLabel(data.operationType));
      row.push($this.getPaymentMethodLabel(data.paymentMethod));
      if (data.kiosk != null) {
        row.push(data.kiosk.name);
      } else {
        row.push("-");
      }
      row.push(data.value.toFixed(2));
      rows.push(row.join(','));
    }
    return `${headers}\n${rows.join('\n')}`;
  }
}
